var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 20.7092C10.022 20.7092 9.62534 20.3125 9.62534 19.8342V14.9459L8.78534 15.7859C8.44701 16.1242 7.88701 16.1242 7.54867 15.7859C7.21034 15.4475 7.21034 14.8875 7.54867 14.5492L9.88201 12.2159C10.127 11.9709 10.512 11.8892 10.8387 12.0292C11.1653 12.1575 11.3753 12.4842 11.3753 12.8342V19.8342C11.3753 20.3125 10.9787 20.7092 10.5003 20.7092Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8338 16.0414C12.6121 16.0414 12.3905 15.9597 12.2155 15.7847L9.88217 13.4514C9.54383 13.113 9.54383 12.553 9.88217 12.2147C10.2205 11.8764 10.7805 11.8764 11.1188 12.2147L13.4521 14.548C13.7905 14.8864 13.7905 15.4464 13.4521 15.7847C13.2771 15.9597 13.0555 16.0414 12.8338 16.0414Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 26.5404H10.5002C4.16516 26.5404 1.4585 23.8337 1.4585 17.4987V10.4987C1.4585 4.1637 4.16516 1.45703 10.5002 1.45703H16.3335C16.8118 1.45703 17.2085 1.8537 17.2085 2.33203C17.2085 2.81036 16.8118 3.20703 16.3335 3.20703H10.5002C5.12183 3.20703 3.2085 5.12036 3.2085 10.4987V17.4987C3.2085 22.877 5.12183 24.7904 10.5002 24.7904H17.5002C22.8785 24.7904 24.7918 22.877 24.7918 17.4987V11.6654C24.7918 11.187 25.1885 10.7904 25.6668 10.7904C26.1452 10.7904 26.5418 11.187 26.5418 11.6654V17.4987C26.5418 23.8337 23.8352 26.5404 17.5002 26.5404Z",
    fill: "#BBBBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6668 12.5387H21.0002C17.0102 12.5387 15.4585 10.987 15.4585 6.99698V2.33031C15.4585 1.98031 15.6685 1.65364 15.9952 1.52531C16.3218 1.38531 16.6952 1.46698 16.9518 1.71198L26.2852 11.0453C26.5302 11.2903 26.6118 11.6753 26.4718 12.002C26.3318 12.3287 26.0168 12.5387 25.6668 12.5387ZM17.2085 4.44198V6.99698C17.2085 10.007 17.9902 10.7886 21.0002 10.7886H23.5552L17.2085 4.44198Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFile);
export default __webpack_public_path__ + "static/media/select_file.4433c213d1adc02e718bd330c9cddee6.svg";
export { ForwardRef as ReactComponent };